<template>
  <div class="stock-proposal-actions">
    <app-button data-qa="open-extra-stock" @click="$emit('open-modal')"
      >Bekijk extra voorraad</app-button
    >
  </div>
</template>

<script>
import AppButton from '@/components/generic/presentational/atoms/appButton/AppButton.vue'
import { mapState } from 'vuex'

export default {
  components: { AppButton },
  emits: ['open-modal'],
  computed: {
    ...mapState('stockcars', ['matchingStockCars']),
  },
}
</script>

<style lang="scss" scoped>
.stock-proposal-actions {
  display: flex;
  align-items: center;
  gap: 0.9375rem;
  margin-top: 0.3125rem;
  margin-right: 0.5rem;
}
</style>
